<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <RackNeTree neType='[mc_cms]'></RackNeTree>
    </template>
    <template v-slot:right_view>
      <RackRightPanel></RackRightPanel>
    </template>
  </BasicLayout>
</template>
<script>
  import BasicLayout from '../../../layouts/BasicLayout';
  import RackNeTree from '../../../components/topoconfig/rack/RackLeftTree';
  import RackRightPanel from '../../../components/topoconfig/rack/RackRightPanel';

  export default {
    name: 'RackGraph',
    components: {
      BasicLayout,
      RackNeTree,
      RackRightPanel
    },
    data() {
      return {
        left: {
          show: true,
          name: this.$t('Topo.equipmentList')
        },
        middle: {
          show: false,
          name: ''
        },
        right: {
          show: true,
          crumb: `${this.$t('Topo.topoManager')}/${this.$t('Topo.topoRack')}`
        }
      };
    }
  };
</script>
